function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreePetition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 19v1c0 1.097-.903 2-2 2h-2c-1.097 0-2-.903-2-2v-1zM5 18c-.89 0-1.337-1.077-.707-1.707l2.855-2.857-1.464-.487a1 1 0 0 1-.472-1.565l.08-.091 3.019-3.02-.758-.379a1 1 0 0 1-.343-1.507l.083-.094 4-4a1.004 1.004 0 0 1 1.414 0l4 4a1.002 1.002 0 0 1-.26 1.601l-.759.379 3.02 3.02a1 1 0 0 1-.279 1.61l-.113.046-1.465.487 2.856 2.857c.603.602.22 1.614-.593 1.701L19 18z",
    style: {
      fill: "#051",
      fillRule: "nonzero"
    },
    transform: "translate(-1.271 1.484)scale(.87621)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5 26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3h128c17.7 0 32-14.3 32-32s-14.3-32-32-32h-83.6l18-53.9c3.8-11.3.9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4l-122.5 36.8c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32zm-9.2 177 49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3-4.7 0-8.5-3.8-8.5-8.5v-71.9c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24h40.3c-.2-2.8-.3-5.6-.3-8.5V368zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48z",
    style: {
      fill: "#dedede",
      fillRule: "nonzero"
    },
    transform: "translate(4.315 9.377)scale(.0154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79 0 22.8-9.9 44.6-27.1 59.6L277.7 319 193 234.3zM170.3 256.9l84.8 84.8-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.3 510.3l95.4-95.4c2.6.7 5.4 1.1 8.3 1.1 17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32c0 2.9.4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z",
    style: {
      fill: "#7c67ff",
      fillRule: "nonzero"
    },
    transform: "rotate(-22.48 24.822 -28.616)scale(.01754)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreePetition);
export default __webpack_public_path__ + "static/media/TreePetition.afa848544c322cb373875479e2df7bcd.svg";
export { ForwardRef as ReactComponent };